import { render, staticRenderFns } from "./ProductsNew.vue?vue&type=template&id=48566c35"
import script from "./ProductsNew.vue?vue&type=script&lang=js"
export * from "./ProductsNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports